import React, { useLayoutEffect, useRef, useState } from 'react';
import ProjectListRow from './ProjectListRow';

const ROW_GAP = 8; /* space-y-2 */
export const ROWS_VISIBLE = 10;

/**
 * Every project, ten rows at a time, the rest behind a scroll.
 *
 * The height is measured from the first row rather than assumed, because a
 * row is two lines tall when the project has an address and one line when it
 * does not - a hard-coded pixel height would show eight rows on one page and
 * thirteen on another. The measurement is redone whenever the number of rows
 * changes, which is also when a filter or a window resize would have changed
 * the wrapping.
 *
 * If the measurement comes back zero the list is left uncapped and simply
 * shows everything. That is the case under jsdom, which reports no layout at
 * all; an uncapped list is the harmless failure here, a collapsed one is not.
 */
export default function ProjectList({ projects, percentFor, changeStatus = false }) {
  const listRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  useLayoutEffect(() => {
    const row = listRef.current?.firstElementChild;
    const rowHeight = row?.getBoundingClientRect().height || 0;
    if (!rowHeight || projects.length <= ROWS_VISIBLE) {
      setMaxHeight(null);
      return;
    }
    setMaxHeight(rowHeight * ROWS_VISIBLE + ROW_GAP * (ROWS_VISIBLE - 1));
  }, [projects.length]);

  return (
    <div
      className={maxHeight ? 'overflow-y-auto pr-1' : ''}
      style={maxHeight ? { maxHeight } : undefined}
    >
      <div ref={listRef} className="space-y-2">
        {projects.map(p => (
          <ProjectListRow key={p.id} project={p} percentComplete={percentFor(p.id)} changeStatus={changeStatus} />
        ))}
      </div>
    </div>
  );
}
